import Image from 'next/image';
import { useEffect } from 'react';
import { getScreenName } from '../../../Utils/helper';
import {
  BannerTitle,
  GridWrapper,
} from '../../StoreHomePage/BannersGrid/styled';
import {
  AbsoluteText,
  ContentBox,
  ImageBox,
  ImageDescription,
  ImageHeading,
  PerfectDiaperGrid,
} from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function PerfectDiaperForBaby(props) {
  const {
    banner: diaperGridData,
    columnSize,
    scrollUp,
    showGoTop,
    newDiaperVersion,
  } = props;
  const getSizesString = (itemCount) => {
    switch (itemCount) {
      case 4:
        return '(max-width: 720px) 50vw, 50vw';
      case 3:
        return '(max-width: 720px) 100vw, 50vw';
      case 2:
        return '50vw';
      default:
        return '100vw';
    }
  };
  const getDesktopImage = (product) => {
    return product?.desktopImage || product?.mobileWebImage || product?.image;
  };
  const getMobileImage = (product) => {
    return product?.mobileWebImage || product?.desktopImage || product?.image;
  };

  const cardClickHandler = () => {
    fireEvent({
      category: 'clicked_card_in_myloshop',
      screen_name: getScreenName(),
      section_id: '',
      section_name: diaperGridData?.heading,
      shape: 'Banner',
      page_url: window.location.href.slice(0, 99),
    });
    // scrollUp();
  };

  useEffect(() => {
    fireEvent({
      category: 'served_section_in_myloshop',
      screen_name: getScreenName(),
      section_id: '',
      section_name: diaperGridData?.heading,
      shape: 'Banner',
      page_url: window.location.href.slice(0, 99),
    });
  }, []);

  return (
    <GridWrapper>
      <BannerTitle>
        <h2>{diaperGridData?.heading} </h2>
      </BannerTitle>
      <PerfectDiaperGrid
        columnSize={columnSize}
        newDiaperVersion={newDiaperVersion}
      >
        {diaperGridData?.items?.map((element, index) => {
          return (
            <ImageBox onClick={cardClickHandler} key={`heading${index}`}>
              <Image
                src={getMobileImage(element)}
                className={'image carousel-mobile'}
                alt={element?.heading}
                loading="lazy"
                quality={90}
                fill
                sizes={getSizesString(3)}
              />
              <Image
                src={getDesktopImage(element)}
                className={'image carousel-desktop'}
                alt={element?.heading}
                loading="lazy"
                quality={90}
                fill
                sizes={getSizesString(3)}
              />
              {newDiaperVersion ? (
                <ContentBox>
                  <ImageHeading>{element?.heading}</ImageHeading>
                  {element?.subHeading && (
                    <ImageDescription>{element?.subHeading}</ImageDescription>
                  )}
                </ContentBox>
              ) : (
                <AbsoluteText color={element?.textColor}>
                  {element?.heading}
                </AbsoluteText>
              )}
            </ImageBox>
          );
        })}
      </PerfectDiaperGrid>
    </GridWrapper>
  );
}
